import mergeImages from 'merge-images';

const mergeColLabels = async (label1, label2, width = 460, height = 170, totalCols) => {
    const images = [
        { src: label1, x: 0, y: 0 },
        { src: label2, x: width / totalCols, y: 0 },
    ];

    const options = {
        width: width,
        height: height
    };

    const b64 = await mergeImages(images, options);

    return b64;
};

export default mergeColLabels;
